export default{
    state: {
            currentMenu:{
                path:"/",
                name:"main",
                icon:"icon-shouye",
                label: "首页",
            },
            menu:[],
            tabList:[
                    {
                        path:"/",
                        name:"main",
                        icon:"icon-shouye",
                        label: "首页",
                    }
            ]


    },
    mutations: {
            selectMenu(state,val){   
                  if(val.name !=="main")  {
                   state.currentMenu = val
                   let result = state.tabList.findIndex(item=>item.name===val.name)
                   result===-1 ? state.tabList.push(val):""
                  }else{
                    state.currentMenu=""
                  }
            },
            closeTab(state,val){
                    let result = state.tabList.findIndex(item=>item.name===val.name)
                    state.tabList.splice(result,1)
            },
    },
    actions: {},
}
